import { ContractorApi, IContractor, IContractorDetail } from '@/service/api'

class ContractorRepository {
  async getAll (): Promise<IContractor[]> {
    return await contractorApi.getAllContractors()
      .then(response => response.data)
  }

  async getById (shortName: string): Promise<IContractorDetail> {
    return await contractorApi.getContractorById(shortName)
      .then(response => response.data)
  }

  async create (contractor: IContractorDetail): Promise<IContractorDetail> {
    return await contractorApi.createContractor(contractor)
      .then(response => response.data)
  }

  async update (shortName: string, contractor: IContractorDetail): Promise<IContractorDetail> {
    return await contractorApi.updateContractor(shortName, contractor)
      .then(response => response.data)
  }

  async delete (shortName: string): Promise<void> {
    return await contractorApi.deleteContractor(shortName)
      .then(response => response.data)
  }

  async canDelete (shortName: string): Promise<boolean> {
    return await contractorApi.canDeleteContractor(shortName)
      .then(response => response.data.canDelete)
  }
}

const contractorApi = new ContractorApi()
const contractorRepository = new ContractorRepository()
export { contractorRepository }
